import React from 'react'
import { Text } from 'shared/components'

import * as styles from './styles'

const MobileManageAccountSectionComponent = () => {
	return (
		<div css={styles.manageAccountContainer}>
			<div style={{ paddingBottom: '16px' }}>
				<Text size={16} bold css={styles.sectionTitle}>
					Manage account
				</Text>
			</div>
		</div>
	)
}

export default MobileManageAccountSectionComponent 